<template>
  <section id="here">
    <h1>This page does not exists!</h1>
  </section>
</template>

<style scoped>
#here {
  text-align: center;
}
</style>

<script>
export default {
  name: "NotFound404" // Vue note: names help in debugging
};
</script>
